"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PermissionCategory_1 = __importDefault(require("./PermissionCategory"));
const FaxCoverPage_1 = __importDefault(require("./FaxCoverPage"));
const Permission_1 = __importDefault(require("./Permission"));
const UserRole_1 = __importDefault(require("./UserRole"));
const Location_1 = __importDefault(require("./Location"));
const Timezone_1 = __importDefault(require("./Timezone"));
const Greeting_1 = __importDefault(require("./Greeting"));
const Language_1 = __importDefault(require("./Language"));
const Country_1 = __importDefault(require("./Country"));
const State_1 = __importDefault(require("./State"));
const Brand_1 = __importDefault(require("./Brand"));
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/dictionary`;
    }
    brand(brandId = null) {
        return new Brand_1.default(this, brandId);
    }
    state(stateId = null) {
        return new State_1.default(this, stateId);
    }
    country(countryId = null) {
        return new Country_1.default(this, countryId);
    }
    language(languageId = null) {
        return new Language_1.default(this, languageId);
    }
    greeting(greetingId = null) {
        return new Greeting_1.default(this, greetingId);
    }
    timezone(timezoneId = null) {
        return new Timezone_1.default(this, timezoneId);
    }
    location() {
        return new Location_1.default(this);
    }
    userRole(roleId = null) {
        return new UserRole_1.default(this, roleId);
    }
    permission(permissionId = null) {
        return new Permission_1.default(this, permissionId);
    }
    faxCoverPage() {
        return new FaxCoverPage_1.default(this);
    }
    permissionCategory(permissionCategoryId = null) {
        return new PermissionCategory_1.default(this, permissionCategoryId);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map